import React from 'react';
import { WeezHeader, Card, ContentCard, Table, EmptyState, Icon, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { useFilters, handleSearchQuery } from '../../../../manager/components/context';
import CashBalance from '../../../../../models/Cashbalance';
import CheckoutTab from './checkoutTab';
import CheckoutLine from './checkoutLine';
import SearchModule from './searchModule';
import LoadingTable from '../../../../../components/loadingTable';

const spec = {
    multiple: ['partner_id'],
    fields: ['filter_id', 'search'],
    aliases: {},
    date: []
};

const CheckoutReport = ({ organization, ticket_office }) => {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [filters, setFilters] = useFilters(spec);
    const [order, sort] = React.useState('-end_date');
    const [data, loadingData, syncData] = CashBalance.useApiModel(
        {
            organizationId: organization.id,
            ticket_officeId: ticket_office.id,
            cache: false,
            allow_cache: false,
            query: {
                ...handleSearchQuery(spec, filters)
            },
            onError: () => toast.error(t('ticket.checkout.toast.error.retrieval_error'))
        },
        [ticket_office, organization, spec, filters]
    );

    const sortedDatas = React.useMemo(() => {
        if (!data) {
            return [];
        }
        let _data = data?.data;

        switch (order) {
            case 'alpha':
                _data.sort((a, b) => a.name?.localeCompare(b.name));
                break;
            case '-alpha':
                _data.sort((b, a) => a.name?.localeCompare(b.name));
                break;
            case 'crst':
                _data.sort((b, a) => a.session_id - b.session_id);
                break;
            case '-crst':
                _data.sort((a, b) => a.session_id - b.session_id);
                break;
            case 'start_date':
                _data.sort((a, b) => a.start_date?.localeCompare(b.start_date));
                break;
            case '-start_date':
                _data.sort((b, a) => a.start_date?.localeCompare(b.start_date));
                break;
            case 'end_date':
                _data.sort((b, a) => a.end_date?.localeCompare(b.end_date));
                break;
            case '-end_date':
                _data.sort((b, a) => a.end_date?.localeCompare(b.end_date));
                break;
            default:
                break;
        }
        return _data;
    }, [data, order]);

    const filteredDatas = React.useMemo(() => {
        let _datas = sortedDatas;
        if (filters['filter_id'] === 'inProgress') {
            _datas = sortedDatas.filter(d => {
                return Number(d.closed) === 0;
            });
        } else if (filters['filter_id'] === 'finish') {
            _datas = sortedDatas.filter(d => {
                return Number(d.closed) === 1;
            });
        }
        if (Boolean(filters?.search) && filters.search.length > 0) {
            const reg = new RegExp(filters.search, 'gi');
            return _datas?.filter(d => d.name?.match(reg));
        }
        return _datas;
    }, [sortedDatas, filters]);

    return (
        <div>
            <WeezHeader title={t('ticket.checkout.header.name')}>{t('ticket.checkout.header.subtitle')}</WeezHeader>
            <Card>
                <ContentCard>
                    <SearchModule ticket_office={ticket_office} displayData={filteredDatas} filters={filters} setFilters={setFilters} loadingCount={loadingData} />
                </ContentCard>
                <Table useNew>
                    <CheckoutTab sort={sort} ordering={order} />
                    <CheckoutLine ticket_office={ticket_office} displayData={filteredDatas} organization={organization} syncData={syncData} />
                </Table>
                <LoadingTable loading={loadingData} />
                {(!loadingData || !data) && !filteredDatas?.length && (
                    <EmptyState icon={<Icon name="list" />} title={t('ticket.checkout.empty.title')} subtitle={t('ticket.checkout.empty.subtitle')} />
                )}
            </Card>
        </div>
    );
};

export default CheckoutReport;
